import script from "./DetailChoose.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailChoose.vue?vue&type=script&lang=ts&setup=true"

import "./DetailChoose.vue?vue&type=style&index=0&id=3d580cda&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d580cda"]])

export default __exports__